import { Component, Input } from '@angular/core'
import { FormGroup } from '@angular/forms'

export interface LexSelectOption {
  label: string
  value: string
}

@Component({
   selector: 'lex-select',
   templateUrl: './lex-select.component.html',
   styleUrls: ['./lex-select.component.css']
})
export class LexSelectComponent {LexSelect
  @Input() name: string
  @Input() label: string
  @Input() formGroup: FormGroup
  @Input() options: LexSelectOption[]
}
